import { EPermissoes } from '@/enums/ePermissoes';
import cadastro from './cadastro/routes';
import relatorios from './relatorios/routes';

const withTipoFornecimento = (routes: any[], utlTipoFornecimentoId: number): any[] =>
  routes.map((route) => ({
    ...route,
    meta: {
      ...route.meta,
      utlTipoFornecimentoId
    },
    children: route.children ? withTipoFornecimento(route.children, utlTipoFornecimentoId) : route.children
  }));

const routes = [
  {
    description: '4. Laudo de Argamassa',
    path: 'laudo',
    name: 'laudoArgamassa',
    component: () => import('@/views/controle-tecnologico/laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'Argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Laudo de Argamassa',
    path: 'laudo/incluir/:tipoEnsaioId/:laboratorioId',
    name: 'laudoinsertArgamassa',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoArgamassa',
      utlTipoFornecimentoId: 3,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Edição de Laudo de Argamassa',
    path: 'laudo/editar/:id/:tipoEnsaioId/:laboratorioId',
    name: 'laudoUpdateArgamassa',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoArgamassa',
      utlTipoFornecimentoId: 3,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Revisão de Laudo de Argamassa',
    path: 'revisao-laudo',
    name: 'revisaolaudoArgamassa',
    component: () => import('@/views/controle-tecnologico/aprovacao-laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Aprovacao_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: '1. Recebimento de Argamassa',
    path: 'recebimento',
    name: 'recebimentoargamassa',
    component: () => import('@/views/concreto/recebimento-graute-argamassa/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 3,
      tipoConcreto: 3,
      permissions: [EPermissoes.Lancamento_Recebimento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Recebimento de Argamassa',
    path: 'recebimento/incluir',
    name: 'recebimentoargamassainsert',
    component: () => import('@/views/concreto/recebimento-graute-argamassa/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentoargamassa',
      utlTipoFornecimentoId: 3,
      tipoConcreto: 3,
      permissions: [EPermissoes.Lancamento_Recebimento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Recebimento de Argamassa',
    path: 'recebimento/editar/:id',
    name: 'recebimentoargamassaupdate',
    component: () => import('@/views/concreto/recebimento-graute-argamassa/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentoargamassa',
      utlTipoFornecimentoId: 3,
      tipoConcreto: 3,
      permissions: [EPermissoes.Lancamento_Recebimento]
    },
    goesToMenu: false
  },
  {
    description: '2. Aplicação de Argamassa',
    path: 'aplicacao',
    name: 'aplicacaoargamassa',
    component: () => import('@/views/utilidade/aplicacao-ambiente/Index.vue'),
    meta: {
      tipoFornecimento: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento_Aplicacao],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Aplicação de Argamassa',
    path: 'aplicacao/incluir',
    name: 'inclusaoaplicacaoargamassa',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaoargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Aplicação de Argamassa',
    path: 'aplicacao/editar/:protocolo',
    name: 'aplicacaoargamassaupdate',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaoargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: '3. Ensaio de Argamassa',
    path: 'ensaio',
    name: 'ensaioargamassa',
    component: () => import('@/views/utilidade/ensaio/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão/Edição de Ensaio de Argamassa',
    path: 'ensaio/incluir',
    name: 'InclusaoEdicaoEnsaioArgamassa',
    component: () => import('@/views/utilidade/ensaio/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'ensaioargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios]
    }
  },
  {
    description: 'Lote de Argamassa',
    path: 'lote',
    name: 'produtofornecedorloteargamassa',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Lote de Argamassa',
    path: 'lote/incluir?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorloteargamassainsert',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorloteargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Lote de Argamassa',
    path: 'lote/editar/:id?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorloteargamassaupdate',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorloteargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    description: '5. Traço Experimental',
    path: 'traco-experimental',
    name: 'tracoExperimentalArgamassa',
    component: () => import('@/views/concreto/traco-experimental/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoConcreto: 3,
      permissions: [EPermissoes.Lancamento_Recebimento],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Traço Experimental de Argamassa',
    path: 'traco-experimental/incluir',
    name: 'tracoExperimentalArgamassainsert',
    component: () => import('@/views/concreto/traco-experimental/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: { parentRouteName: 'tracoExperimentalArgamassa', tipoConcreto: 3, permissions: [EPermissoes.Lancamento_Recebimento] }
  },
  {
    description: 'Edição de Traço Experimental de Argamassa',
    path: 'traco-experimental/editar/:id',
    name: 'tracoExperimentalArgamassaupdate',
    component: () => import('@/views/concreto/traco-experimental/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: { parentRouteName: 'tracoExperimentalArgamassa', tipoConcreto: 3, permissions: [EPermissoes.Lancamento_Recebimento] }
  },
  {
    path: 'cadastro',
    description: 'Cadastro',
    goesToMenu: false,
    children: cadastro
  },
  {
    path: 'relatorios',
    description: 'Relatórios',
    goesToMenu: false,
    children: relatorios
  }
];

export default [
  {
    path: 'argamassa',
    description: 'Argamassa',
    meta: {
      utlTipoFornecimentoId: 3
    },
    goesToMenu: false,
    children: withTipoFornecimento(routes, 3)
  }
];
